import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ScrollReveal from "scrollreveal";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { axiosInstace } from "../../service/axiosConfig";
import CourseCard from "../courseCard/CourseCard";
import styles from "./MostLearning.module.css";

export default function MostLearning() {
  const { t } = useTranslation();
  const [reviews, setReviews] = useState({});
  const [enrollList, setEnrollList] = useState([]);
  const session = JSON.parse(localStorage.getItem("user_stu") || "{}");
  const navigate = useNavigate();
  const screenWidth = window.innerWidth;


  const navigateCourses = () => {
    navigate("/all-courses");
  };
  const [CoursesList, setCoursesList] = useState([]);
  async function getData() {
    try {
      const data = await axiosInstace.get("/api/courses/v1/courses/?page_size=9");
      setCoursesList(data.data.results);

      // console.log(data, "data.data");
    } catch (error) {
      console.log('error', error)
    }
  }

  function getReviews() {
    axios
      .get(`https://forms.eyouthlearning.com/v1/reviews/eyouth/courses`)
      .then((res) => {
        setReviews(res.data.results);
      })
      .catch((err) => setReviews(err, "err from reviews"));
  }
  const getEnrollment = () => {
    axiosInstace
      .get(`/api/enrollment/v1/enrollment`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${session.access_token}`,
        },
      })
      .then((res) => {
        setEnrollList(res.data);
      })
      .catch((err) => err);
  };

  useEffect(() => {
    if (session.access_token) getEnrollment();
    getData();
    getReviews();
    // eslint-disable-next-line
  }, []);
  const h2eRef = useRef(null);
  const sliderRef = useRef(null);
  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(sliderRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "left",
      reset: false,
    });
    sr.reveal(h2eRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "right",
      reset: false,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={` container-fluid ${styles.AllCourses}`}>
        <div className="w-25 px-3" ref={h2eRef}>
          <h2 className={`${styles.fontTitleMobile} `}>
            {t("Our best selling courses")}
          </h2>
        </div>
        <div className={`${styles.divSwiper} w-75`} ref={sliderRef}>
          <Swiper
            // dir={i18next.language === "en" ? "ltr" : "rtl"}
            dir="ltr"

            spaceBetween={0}
            slidesPerView={3}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className={`mySwiper ${styles.webViewSwiper} `}
          >
            {CoursesList.map((course, index) => {
              return (
                <SwiperSlide
                  className=" d-flex  justify-content-center "
                  key={index}
                >
                  <CourseCard
                    enrollList={enrollList}
                    key={index}
                    course={course}
                    reviews={reviews}
                    classes={styles.animationAndShadow}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
          <Swiper
            // dir={i18next.language === "en" ? "ltr" : "rtl"}
            spaceBetween={60}
            slidesPerView={1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className={`mySwiper ${styles.mobileViewSwiper} `}
          >
            {CoursesList.map((course, index) => {
              return (
                <SwiperSlide
                  className=" d-flex  justify-content-center "
                  key={index}
                >
                  <CourseCard
                    enrollList={enrollList}
                    key={index}
                    course={course}
                    reviews={reviews}
                    classes={styles.animationAndShadow}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>

        </div>
      </div>
      {/* button Mobile and web */}
      <div className={`${styles.mobile_view} ${styles.web_view}`}>
        <button
          aria-label="button to be clicked"
          aria-labelledby="button to be clicked"
          className={`btn btn-primary ${styles.btn_all_mobile} ${styles.btn_all}`}
          onClick={navigateCourses}
        >
          {t("View All")}
        </button>
      </div>

    </>
  );
}
